import {
  IGeoJson2DGeographicCoordinates,
  LocationType,
  PositionSource,
} from '~/client/graph'
import LocationBase from '~/client/src/shared/models/LocationObjects/LocationBase'
import OffloadingEquipment from '~/client/src/shared/models/LocationObjects/OffloadingEquipment'

function isLivePositioned(dataObject: LocationBase): boolean {
  if (!dataObject?.is(LocationType.OffloadingEquipment)) {
    return false
  }
  return (
    (dataObject as OffloadingEquipment).effectivePosition?.source ===
    PositionSource.Live
  )
}

export function liveCoordinates(
  dataObject: LocationBase,
): IGeoJson2DGeographicCoordinates | null {
  if (!isLivePositioned(dataObject)) {
    return null
  }
  const { latitude, longitude } = (dataObject as OffloadingEquipment)
    .effectivePosition
  return latitude == null || longitude == null ? null : { latitude, longitude }
}
